<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: 160px;">
    <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="width: 100%; max-width: 200px;">
        <button type="button" class="achat-button me-2">
            <a target="_blank" class="email" title="Chiffre d'affaires" >
                <span data-feather="shopping-cart" class="phone-icon"></span>
            </a>
        </button>
        <div class="d-flex flex-column">
            <span class="number">{{ loading ? '...' : formatMontant(totalFactures) }}</span>
            <span class="phone-number">Chiffre d’affaires</span>
        </div>
    </div>
    <p class="text-danger mb-0" *ngIf="error">{{ error }}</p>
</div>